import { render } from "./BackgroundBigStars.vue?vue&type=template&id=1873a2e8&scoped=true"
import script from "./BackgroundBigStars.vue?vue&type=script&lang=js"
export * from "./BackgroundBigStars.vue?vue&type=script&lang=js"

import "./BackgroundBigStars.vue?vue&type=style&index=0&id=1873a2e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1873a2e8"

export default script